import { BrowseHoverCategory, EverydayCategories, PageCategory, SpecialistCategories } from '@/types/enums/StoreTypes'
import { customerDashboardPath } from '@/lib/namedRoutes'

const quickCareColumn = BrowseHoverCategory.columns.find((c) => c.name === 'Quick care')
const medicationsColumn = BrowseHoverCategory.columns.find((c) => c.name === 'Medications')
const labsColumn = BrowseHoverCategory.columns.find((c) => c.name === 'Labs & Imaging')

export const getCareItems: PageCategory[] = [
    {
        slug: 'quick-care',
        name: 'Quick care',
        href: '#',
        overrideSection: {
            title: 'Quick care',
            menuItems: quickCareColumn?.items ?? [],
        },
    },
    {
        slug: 'everyday-care',
        name: 'Everyday care',
        href: '/store/everyday-care',
        overrideSection: {
            title: 'Everyday care',
            goToButtonHref: '/store/everyday-care',
            menuItems: EverydayCategories,
        },
    },
    {
        slug: 'specialty-care',
        name: 'Specialty care',
        href: '/store/specialty-care',
        overrideSection: {
            title: 'Specialty care',
            goToButtonHref: '/store/specialty-care',
            menuItems: [
                ...SpecialistCategories,
                { slug: 'specialty-care', name: 'See all', href: '/store/specialty-care' },
            ],
        },
    },
    {
        slug: 'medications',
        name: 'Medications',
        href: '/store/medications',
        overrideSection: {
            title: 'Medications',
            goToButtonHref: '/store/medications',
            menuItems: medicationsColumn?.items ?? [],
        },
    },
    {
        slug: 'lab-tests',
        name: 'Lab tests',
        href: '/store/labs',
        overrideSection: {
            title: 'Lab tests',
            goToButtonHref: '/store/labs',
            menuItems: labsColumn?.items ?? [],
        },
    },
    { slug: 'general-ai', name: 'General AI', href: '/ai' },
]

export const accountDashboardAccountItems: PageCategory[] = [
    { slug: 'account-home', name: 'Account home', href: customerDashboardPath },
    { slug: 'my-care', name: 'My care', href: '/account/my-care' },
    { slug: 'medications', name: 'Medications', href: '/account/medications' },
    { slug: 'updates', name: 'Updates', href: '/account/updates' },
    { slug: 'orders', name: 'Orders', href: '/account/orders' },
    { slug: 'profile', name: 'Profile & billing', href: '/account/profile' },
]

const accountDashboardMessagesItem: PageCategory = {
    slug: 'messages',
    name: 'Messages',
    href: '/account/messages',
}

/**
 * Mirrors the account dashboard side nav's "Your account" links, inserting
 * Messages after Updates (matching `AccountDashboardShell`'s nav item order)
 * only when the message center flag is also on.
 */
export function getAccountDashboardAccountItems(messageCenterEnabled: boolean): PageCategory[] {
    if (!messageCenterEnabled) return accountDashboardAccountItems

    const updatesIndex = accountDashboardAccountItems.findIndex((item) => item.slug === 'updates')
    return [
        ...accountDashboardAccountItems.slice(0, updatesIndex + 1),
        accountDashboardMessagesItem,
        ...accountDashboardAccountItems.slice(updatesIndex + 1),
    ]
}

export const companyItems: PageCategory[] = [
    { slug: 'how-it-works', name: 'How it works', href: 'https://generalmedicine.co/how-it-works' },
    { slug: 'about', name: 'About us', href: 'https://generalmedicine.co/company/about' },
    { slug: 'careers', name: 'Careers', href: 'https://generalmedicine.co/company/careers' },
    { slug: 'support', name: 'Support', href: 'https://generalmedicine.co/support/help-center' },
    { slug: 'resources', name: 'Resources', href: 'https://generalmedicine.co/resources' },
]
